<div class="popup-overlay" (click)="close()">
  <div class="popup takeaway-full" (click)="$event.stopPropagation()">
    <button class="popup-close-btn" (click)="close()">✕</button>
    <p class="note-text">
      Please note: Orders require a minimum of 45 minutes to be prepared.
    </p>

    <div class="takeaway-header">
      <h1>Take away</h1>
    </div>

    <div class="header">
      <input
        type="text"
        class="search-bar"
        placeholder="Search dishes..."
        [(ngModel)]="searchQuery"
        (ngModelChange)="onSearchChange()"
      />

      <button class="menu-btn" (click)="toggleMenuPopup()">☰ Menu</button>
    </div>

    @if (menuOpen) {
      <div class="menu-popup" (click)="toggleMenuPopup()">
        <div class="menu-popup-content" (click)="$event.stopPropagation()">
          <div class="menu-header">
            <h3>Menu Categories</h3>
            <button class="close-btn" (click)="toggleMenuPopup()">✕</button>
          </div>

          <ul>
            <li
              [class.active]="selectedCategory === ''"
              (click)="selectCategory('')"
            >
              All Dishes
            </li>

            @for (cat of categories; track cat) {
              <li
                [class.active]="selectedCategory === cat"
                (click)="selectCategory(cat)"
              >
                {{ cat }}
              </li>
            }
          </ul>
        </div>
      </div>
    }

    <div class="dish-section">
      <h2 class="section-title">{{ selectedCategory || "All Dishes" }}</h2>

      <div class="dish-grid">
        @if (loading) {
          @for (n of skeletonArray(); track $index) {
            <div class="dish-card skeleton-card">
              <div class="skeleton-img shimmer"></div>
              <div class="dish-info">
                <div
                  class="skeleton-line shimmer"
                  style="width: 60%; height: 16px; margin-bottom: 8px"
                ></div>
                <div
                  class="skeleton-line shimmer"
                  style="width: 80%; height: 12px"
                ></div>
              </div>
              <div class="dish-controls">
                <div class="skeleton-button shimmer"></div>
              </div>
            </div>
          }
        } @else {
          @for (dish of filteredDishes(); track dish.id; let i = $index) {
            <div class="dish-card">
              <div class="dish-media">
                @if (dish.dishImages.length > 0) {
                  <div class="dish-carousel">
                    <div class="carousel-wrapper">
                      @if (dish.dishImages.length > 1) {
                        <button
                          class="carousel-btn left"
                          (click)="prevImage(dish, $event)"
                        >
                          ‹
                        </button>
                      }

                      <img
                        [src]="dish.dishImages[dish.currentImageIndex]?.url"
                        alt="{{ dish.name }}"
                      />

                      @if (dish.dishImages.length > 1) {
                        <button
                          class="carousel-btn right"
                          (click)="nextImage(dish, $event)"
                        >
                          ›
                        </button>
                      }
                    </div>

                    <div class="carousel-indicators">
                      @for (
                        img of dish.dishImages;
                        track img.url;
                        let idx = $index
                      ) {
                        <span
                          [class.active]="idx === dish.currentImageIndex"
                          (click)="goToImage(dish, idx)"
                        ></span>
                      }
                    </div>
                  </div>
                } @else {
                  <div class="dish-placeholder">
                    <div class="placeholder-icon">🍽️</div>
                    <div class="placeholder-text">No image available</div>
                  </div>
                }
              </div>
              <div class="dish-info">
                <h3>{{ dish.name }}</h3>
                <p
                  #descEl
                  class="dish-desc"
                  [matTooltip]="isTextClamped(descEl) ? dish.description : ''"
                  [matTooltipDisabled]="!isTextClamped(descEl)"
                  matTooltipClass="amenities-tooltip"
                  matTooltipPosition="above"
                >
                  {{ dish.description }}
                </p>

                <strong>₹{{ dish.price }}</strong>
              </div>

              <div class="dish-controls">
                @if (!getDishInCart(dish)) {
                  <button class="add-btn" (click)="addToCart(dish)">Add</button>
                } @else {
                  <div class="qty-controls">
                    <button (click)="decreaseQty(getDishInCart(dish))">
                      −
                    </button>
                    <span>{{ getDishInCart(dish)?.qty }}</span>
                    <button (click)="increaseQty(getDishInCart(dish))">
                      +
                    </button>
                  </div>
                }
              </div>
            </div>
          }
        }
      </div>
    </div>

    @if (cartOpen) {
      <div class="cart-popup-bottom" (click)="toggleCartPopup()">
        <div class="cart-popup-content" (click)="$event.stopPropagation()">
          <div class="cart-header">
            <h3>Your Cart</h3>
            <button class="close-btn" (click)="toggleCartPopup()">✕</button>
          </div>

          @if (cart.length === 0) {
            <div class="empty-cart">Your cart is empty.</div>
          } @else {
            <div class="cart-items">
              @for (item of cart; track item.id; let ci = $index) {
                <div class="cart-item">
                  <div class="cart-info">
                    <strong>{{ item.name }}</strong>
                    <p>₹{{ item.price }} × {{ item.qty }}</p>
                  </div>

                  <div class="cart-controls">
                    <button (click)="decreaseQty(item)">−</button>
                    <span>{{ item.qty }}</span>
                    <button (click)="increaseQty(item)">+</button>
                  </div>
                </div>
              }
            </div>

            <div class="cart-footer">
              <div class="price-breakup">
                <div class="cooking-instruction-box">
                  <button
                    type="button"
                    class="cooking-request-btn"
                    (click)="toggleCookingInstruction()"
                  >
                    ✎ Cooking requests
                  </button>

                  @if (showCookingInstruction) {
                    <div class="textarea-wrap">
                      <textarea
                        class="cooking-instruction-textarea"
                        rows="3"
                        placeholder="Type cooking requests"
                        [(ngModel)]="cookingInstruction"
                        maxlength="200"
                      ></textarea>

                      <small class="char-count">
                        {{ cookingInstruction.length || 0 }}/200
                      </small>
                    </div>
                  }
                </div>
                <p>
                  <span>Subtotal:</span>
                  <strong>₹{{ totalPrice() }}</strong>
                </p>

                <p>
                  <span>GST Charges:</span>
                  <strong>₹{{ gstAmount() }}</strong>
                </p>

                <p>
                  <span>Packaging Charge:</span>
                  <strong>₹{{ packagingCharge() }}</strong>
                </p>

                <p class="grand-total">
                  <span>Total Payable:</span>
                  <strong>₹{{ payableAmount() }}</strong>
                </p>
              </div>

              <button class="checkout-btn" (click)="toggleCheckoutPopup()">
                Checkout
              </button>
            </div>
          }
        </div>
      </div>
    }

    @if (checkoutOpen) {
      <div class="checkout-popup-overlay" (click)="toggleCheckoutPopup()">
        <div class="checkout-popup-content" (click)="$event.stopPropagation()">
          <div class="checkout-header">
            <h3>Personal details</h3>
            <button class="close-btn" (click)="toggleCheckoutPopup()">✕</button>
          </div>

          <form #checkoutForm="ngForm" (ngSubmit)="submitOrder(checkoutForm)">
            <div class="form-group">
              <label for="name">Name</label>
              <input
                id="name"
                name="customerName"
                type="text"
                [(ngModel)]="customerName"
                #nameCtrl="ngModel"
                required
                minlength="3"
                pattern="^[A-Za-z][A-Za-z\s]*$"
                (blur)="customerName = customerName.trim()"
                placeholder="Enter your name"
              />

              @if (
                nameCtrl.invalid &&
                (nameCtrl.dirty || nameCtrl.touched || checkoutForm.submitted)
              ) {
                <div class="error">
                  @if (nameCtrl.errors?.["required"]) {
                    <div>Name is required</div>
                  }
                  @if (nameCtrl.errors?.["minlength"]) {
                    <div>Name must be at least 3 characters</div>
                  }
                  @if (nameCtrl.errors?.["pattern"]) {
                    <div>
                      Name must start with a letter and contain only letters and
                      spaces
                    </div>
                  }
                </div>
              }
            </div>

            <div class="form-group">
              <label for="mobile">Mobile Number</label>
              <input
                id="mobile"
                name="customerContact"
                type="tel"
                [(ngModel)]="customerContact"
                #mobileCtrl="ngModel"
                required
                pattern="^[6-9][0-9]{9}$"
                placeholder="Enter 10-digit mobile number"
              />

              @if (
                mobileCtrl.invalid &&
                (mobileCtrl.dirty ||
                  mobileCtrl.touched ||
                  checkoutForm.submitted)
              ) {
                <div class="error">
                  @if (mobileCtrl.errors?.["required"]) {
                    <div>Mobile number is required</div>
                  }
                  @if (mobileCtrl.errors?.["pattern"]) {
                    <div>Enter a valid 10-digit Indian mobile number</div>
                  }
                </div>
              }
            </div>

            <div class="form-group">
              <label for="email">Email Address</label>
              <input
                id="email"
                name="customerEmail"
                type="email"
                [(ngModel)]="customerEmail"
                #emailCtrl="ngModel"
                required
                email
                placeholder="Enter your email address"
                (blur)="customerEmail = customerEmail.trim()"
              />

              @if (
                emailCtrl.invalid &&
                (emailCtrl.dirty || emailCtrl.touched || checkoutForm.submitted)
              ) {
                <div class="error">
                  @if (emailCtrl.errors?.["required"]) {
                    <div>Email is required</div>
                  }
                  @if (emailCtrl.errors?.["email"]) {
                    <div>Enter a valid email address</div>
                  }
                </div>
              }
            </div>

            <button type="submit" class="proceed-btn" [disabled]="loading">
              {{ loading ? "Processing..." : "Proceed to Pay" }}
            </button>
          </form>
        </div>
      </div>
    }

    @if (cart.length > 0) {
      <button class="cart-icon-btn" (click)="toggleCartPopup()">
        <div class="cart-wrapper">
          <img
            src="assets/images/icons/add co Bag.svg"
            alt="Cart"
            class="cart-icon"
          />
          <span class="cart-badge">{{ totalItems() }}</span>
        </div>
      </button>
    }

    @if (paymentLoading) {
      <div class="payment-loader-overlay">
        <div class="payment-loader">
          <div class="spinner"></div>
          <p>Processing payment, please wait...</p>
        </div>
      </div>
    }
  </div>
</div>
